<template>
  <div class="filePeople" v-show="childFalse">
    <div class="topBox">
      <!-- <el-button @click="childback" type="">返回</el-button> -->
      <el-button type="primary" @click="childback">
        <h-icon icon="icon-shangyi" rotate="-90"></h-icon>
        返回上一级</el-button
      >
    </div>
    <div class="bottomBox">
      <el-card class="tree-card" :body-style="treeCard">
        <div class="basic">
          <div class="basicTitle">基本信息</div>
          <div class="basicImgbox">
            <div class="basicImg">
              <img
                v-if="peopleList.imageUrl"
                :src="imgURL + peopleList.imageUrl"
              />
              <img v-else src="~@/assets/images/moren.png" />
            </div>
            <div class="basicName">
              <div class="basicItem">
                <span>国籍:</span>
                <span>{{ peopleList.nationalityDict }}</span>
              </div>
              <div class="basicItem">
                <span>姓名:</span>
                <span>{{ peopleList.name }}</span>
              </div>
              <div class="basicItem">
                <span>性别:</span>
                <span>{{ peopleList.sexDict }}</span>
              </div>
              <div class="basicItem">
                <span>民族:</span>
                <span>{{ peopleList.nationDict }}</span>
              </div>
            </div>
          </div>
          <div class="basicItem">
            <span>证件号码:</span>
            <span>{{ peopleList.cardNumber }}</span>
          </div>
          <div class="basicItem">
            <span>出生日期:</span>
            <span>{{ peopleList.birthday }}</span>
          </div>
          <div class="basicItem">
            <span>婚姻状况:</span>
            <span>{{ peopleList.maritalDict }}</span>
          </div>
          <div class="basicTitle">实际居住地址</div>
          <div class="basicItem">
            <span>省市(县)区:</span>
            <span>{{ peopleList.unitCode }}</span>
          </div>
          <div class="basicItem">
            <span>详细地址:</span>
            <span>{{ peopleList.registerDetail }}</span>
          </div>
          <div class="basicItem">
            <span>与房主关系:</span>
            <span>{{ peopleList.relationDict }}</span>
          </div>
          <div class="basicTitle">户籍地址</div>
          <div class="basicItem">
            <span>省市(县)区:</span>
            <span>{{ peopleList.registerName }}</span>
          </div>
          <div class="basicItem">
            <span>区划内详细地址:</span>
            <span>{{ peopleList.registerDetail }}</span>
          </div>
          <div class="basicItem">
            <span>电话:</span>
            <span>{{ peopleList.telphone }}</span>
          </div>
          <div class="basicTitle">其他信息</div>
          <div class="basicItem">
            <span>职业:</span>
            <span>{{ peopleList.job }}</span>
          </div>
          <div class="basicItem">
            <span>职业类别:</span>
            <span>{{ peopleList.jobTypeDict }}</span>
          </div>
          <div class="basicItem">
            <span>人户一致标示:</span>
            <span>{{ peopleList.codeDict }}</span>
          </div>
          <div class="basicItem">
            <span>人口管理类别:</span>
            <span>{{ peopleList.prisonTypeDict }}</span>
          </div>
          <div class="basicItem">
            <span>备注:</span>
            <span>{{ peopleList.comment }}</span>
          </div>
          <div class="basicItem">
            <span>登记人:</span>
            <span>{{ peopleList.userName }}</span>
          </div>
          <div class="basicItem">
            <span>登记时间:</span>
            <span>{{ peopleList.createTime }}</span>
          </div>
          <!-- <div class="basicItem">
            <span>登记单位:</span>
            <span>{{peopleList}}</span>
          </div> -->
        </div>
      </el-card>
      <div class="rightcenter">
        <commentright
          :dialogCount="peopleList"
          :showType="showType"
        ></commentright>
      </div>
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  watch,
  nextTick,
} from "vue";
import commentright from "./commentright";
import { infoQuery } from "@/api/realPopulation/realPopulation";
// import nameJson from "@/views/threeSolid/fileManagement/nameJson.json";
import {
  communityright,
  equipmentright,
  powerright,
  securityright,
} from "./fileManagement";
export default defineComponent({
  name: "",
  components: { commentright },
  props: {
    grandsonVisible: {
      type: Boolean,
    },
    showType: {
      type: String,
    },
    prisonId: {
      type: Number,
    },
    indexs: {
      type: Number,
    },
  },
  setup(props, context) {
    const data = reactive({
      imgURL: window.imgURL,
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      childFalse: false,
      peopleList: {},
      prisonIds: 0,
      modelShow: "houseInfoList",
      centerList: [],
      obj: {
        houseInfo: {},
      },
      tableData: [],
    });
    const refData = toRefs(data);
    watchEffect(() => {
      data.childFalse = props.grandsonVisible;
    });
    watch(
      () => props.prisonId,
      (v) => {
        data.prisonIds = v;
        if (v) {
          nextTick(() => {
            leftList();
          });
        }
      },
      { immediate: true }
    );
    watchEffect(() => {
      context.emit("update:grandsonVisible", data.childFalse);
    });
    // 左侧信息
    const leftList = async () => {
      if (props.showType === "1") {
        const res = await infoQuery(data.prisonIds);
        data.peopleList = res.prisonInfo;
        console.log(props.indexs, 55555);
        if (props.indexs < 2) {
          // const regionInfoList = nameJson;
          // 在这弄的假数据
          // data.peopleList.furtherList =
          //   data.peopleList.furtherList.concat(regionInfoList);
          data.peopleList.furtherList = data.peopleList.furtherList;
        }
        console.log(111, data.peopleList);
      }
    };
    // 点击中间切换
    const clickCenter = (item) => {
      data.modelShow = item.further;
      leftList();
    };

    // 点击返回
    const childback = () => {
      data.childFalse = false;
    };

    return {
      ...refData,
      childback,
      clickCenter,
      communityright,
      equipmentright,
      powerright,
      securityright,
    };
  },
});
</script>
<style lang="scss" scoped>
.rightcenter {
  flex: 1;
}
.filePeople {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  color: #000;
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  .topBox {
    line-height: 15px;
    border-bottom: 1px solid #f1f2f5;
    margin: 0 20px 10px;
  }
  .bottomBox {
    display: flex;
    flex: 1;
    overflow: auto;
  }
  .tree-card {
    height: 100%;
    width: 400px;
  }
  .basic {
    width: 100%;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    padding: 0 8px;
    .basicTitle {
      color: #000;
      line-height: 40px;
      font-weight: bold;
    }
    .basicImgbox {
      width: 100%;
      height: 180px;
      display: flex;
      .basicImg {
        width: 150px;
        height: 100%;
        margin-right: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .basicName {
        flex: 1;
      }
    }
    .basicItem {
      flex: 1;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #f1f2f5;
      padding: 10px 0;
      line-height: 24px;
      // span{
      //   // width: 206px;
      // }
    }
  }
  .center-card {
    flex: 1;
    position: relative;
    .centerbg {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      width: 386px;
      height: 386px;
      img {
        width: 100%;
        height: 100%;
      }
      .imgone {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .imgtwo {
        width: 75%;
        height: 75%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .imgthree {
        width: 50%;
        height: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-image: url("~@/assets/images/threeSolid/threecor.png");
        background-size: 100%;
        img {
          width: 100%;
          height: 100%;
          border-radius: 100%;
        }
      }
    }
    .centerbtn {
      width: 386px;
      height: 386px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .btnitem {
        width: 66px;
        height: 66px;
        text-align: center;
        line-height: 66px;
        border-radius: 100%;
        color: #fff;
        background: #388ff3;
        position: absolute;
        cursor: pointer;
        &:nth-child(1) {
          left: 50%;
          top: -30px;
        }
        &:nth-child(2) {
          left: 75%;
          top: 30px;
        }
        &:nth-child(3) {
          left: 90%;
          top: 50%;
        }
        &:nth-child(4) {
          left: 70%;
          top: 83%;
        }
        &:nth-child(5) {
          left: 35%;
          bottom: -27px;
        }
        &:nth-child(6) {
          left: 20%;
          bottom: 61px;
          width: 45px;
          height: 45px;
          line-height: 42px;
        }
        &:nth-child(7) {
          left: -3%;
          bottom: 24%;
        }
        &:nth-child(8) {
          left: -1%;
          top: 110px;
        }
        &:nth-child(9) {
          left: 10%;
          top: 0px;
        }
      }
    }
  }
  .search-results {
    width: 100%;
    flex: 1;
    overflow: auto;
    margin-top: 5px;
    .results-item {
      padding: 10px 0;
      width: 100%;
      border-bottom: 1px solid #aab2c5;
      @include flex-row-s-c;
      .item-img {
        width: 100px;
        img {
          width: 100%;
        }
      }
      .item-details {
        flex: 1;
        margin-left: 10px;
        line-height: 28px;
        .details-info {
          font-size: 14px;
          @include flex-row-sb-c;
          & > span {
            display: inline-block;
          }
          .label {
            width: 90px;
          }
          .value {
            flex: 1;
          }
        }
      }
    }
  }
}
</style>
